import React from 'react';
import { NavLink } from 'react-router-dom';
import HomeImg from "../Img/Hero SVGheroimg2.png";
import { PortfolioCard } from './PortfolioCard';
import { Title } from "./Title";
import cardImg1 from '../Img/keep-Notes.png';
import cardImg2 from '../Img/Mobile_Banner_IPRU_EDGE_cropped.jpg';
import cardImg3 from '../Img/Ip_address_tracker.png';

export const Home = () => {

    return (
        <>
            <section className="container" >
                <div id="Home">
                    <div className="row">
                        <div data-aos="fade-right" className="col-1">
                            <h1>Crafting <br /> Awesomeness</h1>
                            <p>Avesh Khan is an India-based Web Developer & UIUX Designer and enjoys creating striking visuals. Follow him on Instagram, stalk him on Linkedin, or just say hello.</p>
                            <NavLink to="/about" className="custom-btn btn-17 d-flex-center"> See more </NavLink>
                        </div>
                        <div data-aos="fade-left" className="col-1" >
                            <img src={HomeImg} alt="" />
                        </div>
                    </div>
                </div>
                <Title
                    title="SOME OF MY WORK"
                />
                <div className="works">
                    <div className="row">
                        <PortfolioCard
                            cardImg={cardImg1}
                            cardTitle="Keep Notes"
                            cardSpecify="Notes Taking App build on MERN stack, OAuth2.0 and PrimeReact. with Dark and Light modes"
                            url="https://keep-notes-ashy-chi.vercel.app/"
                            skill_1="react"
                            skill_2="nodejs"
                            skill_3="mongodb"
                        />
                        <PortfolioCard
                            cardImg={cardImg2}
                            cardTitle="IPRU EDGE"
                            cardSpecify="Designed modern & interactive UI/UX for ICICI Prudential Advisors"
                            url="https://www.figma.com/file/cRvCeHIQP5S74gVTaV19NO/advisor-app?type=design&node-id=0%3A1&mode=design&t=OoXMhDuiEo5R9fSM-1"
                            skill_1="figma"
                        />
                        <PortfolioCard
                            cardImg={cardImg3}
                            cardTitle="Ip-address-tracker"
                            cardSpecify="Public IP address tracker created with ipgeo api & react-leaflet"
                            url="https://reactjs-ip-address-tracker.vercel.app/"
                            skill_1="react"
                            skill_2="javascript"
                            skill_3="bootstrap"
                        />

                    </div>
                    <div className="row view-more d-flex-center">
                        <NavLink to="/portfolio"><h3 className="custom-btn btn-7"><span> View more</span></h3></NavLink>
                    </div>
                </div>
            </section>
        </>
    )
}